module.exports = __webpack_public_path__ + "assets/img/51.b141d743.png";